<nav class="navbar" role="navigation" aria-label="main navigation">
  <div class="navbar-brand is-hidden-widescreen-only">
    <a class="navbar-item">
      <img height="50" src="https://cdn.meinkontowechsel.de/logo.fino.png" />
    </a>
  </div>

  <div id="navbarBasicExample" class="navbar-menu">
    <div class="navbar-start is-align-items-center">
      @for (route of routes; track $index) {
        <div>
          @if (shouldShowRoute(route)) {
            <a class="navbar-item" [routerLink]="route.url" routerLinkActive="active-link">
              <div class="tags has-addons">
                <span
                  class="tag is-dark has-text-weight-bold is-size-6"
                  [attr.data-testid]="route.name + 'Navbar'"
                  [class.has-no-counter]="route.showNoLocks"
                  >{{ route.name + '.title' | translate }}</span
                >
                @if (!route.showNoLocks) {
                  <span class="tag has-background-grey-darker counter is-size-6">
                    <fino-icon icon="Lock Unlock 4" class="has-text-white"></fino-icon>
                    <span class="has-text-white has-text-weight-bold mr-1"
                      >{{ counter[route.name]().open }}
                    </span>
                    <fino-icon icon="Lock 6" class="has-text-danger"></fino-icon>
                    <span class="has-text-danger has-text-weight-bold">
                      {{ counter[route.name]().locked }}
                    </span></span
                  >
                }
              </div>
            </a>
          }
        </div>
      }

      @if (hasMoreDropwdown) {
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link" translate="navbar.more"></a>

          <div class="navbar-dropdown">
            @if (hasRole(Roles.CLARIFICATION)) {
              <a
                class="navbar-item has-text-grey"
                routerLinkActive="has-text-primary"
                [routerLink]="clarificationRoute"
                translate="navbar.clarification"
              ></a>
            }
          </div>
        </div>
      }
    </div>

    <div class="navbar-end">
      <div class="navbar-item has-dropdown is-hoverable country-select">
        <a class="navbar-link"><img src="/assets/country-icons/{{ currentLang() }}.svg" /></a>
        <div class="navbar-dropdown">
          <a class="navbar-item" (click)="chooseLanguage('de')"
            ><img class="mr-3" src="/assets/country-icons/de.svg" />
            <p translate="navbar.german"></p>
          </a>
          <a class="navbar-item" (click)="chooseLanguage('en')">
            <img class="mr-3" src="/assets/country-icons/en.svg" />
            <p translate="navbar.english"></p
          ></a>
        </div>
      </div>
      <div class="navbar-item">
        <div class="buttons">
          <a class="button is-light" (click)="toggleUpright()" translate="navbar.upright"> </a>
          <a class="button is-light" (click)="logout()" translate="navbar.logout"> </a>
        </div>
      </div>
    </div>
  </div>
</nav>
